var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 1C0 .7.1.5.3.3c.4-.4 1-.4 1.4 0L7 5.6 12.3.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-6 6c-.4.4-1 .4-1.4 0l-6-6C.1 1.5 0 1.3 0 1z"}));
}

ChevronDown.defaultProps = {"width":"14","height":"8","viewBox":"0 0 14 8"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
